import { put } from 'redux-saga/effects';
const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:51690/api/' : '/api/';
const getSessionIdApi = 'session/getsessionid';
const initSessionIdApi = 'session/createsessionid';

const sagaUtil = {
  initializeSession: function* () {   
    yield put({ type: 'LOADING', val: 1 });
    try {
      const resp = yield (sagaUtil.get(baseUrl + getSessionIdApi).then((r) => r.json()));
      if (!resp.sessionId) {
        yield (sagaUtil.post(baseUrl + initSessionIdApi, null));
      }
    } catch (e) {
      yield put({ type: 'API_EXCEPTION', e });
    }
    finally {
      yield put({ type: 'LOADING', val: -1 });
    }
  },
  get: (url) => {
    console.log('Request GET, URL:' + url);
    return fetch(url, {
      method: "GET",
      credentials: 'include',
    });
  },
  post: (url, data) => {
    console.log('Request POST, URL:' + url);
    console.log('data: ' + JSON.stringify(data));
    return fetch(url, {
      headers: { 'Accept': 'application/json, text/plain, */*', 'Content-Type': 'application/json' },
      method: "POST",
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  fetch: function* (url, data, success, failed, isText = false) {
    //show loading icon
    yield put({ type: 'LOADING', val: 1 });
    try {
      const sessionRes = yield (sagaUtil.get(baseUrl + getSessionIdApi).then(resp => resp.json()));
      if (sessionRes.sessionId) {
        let promise = yield (data ? sagaUtil.post(baseUrl + url, data) : sagaUtil.get(baseUrl + url))
          .then(resp => isText ? resp.text() : resp.json());
        console.log("Response for URL:" + url);
        console.log(promise);
        if (promise && promise.success)
          yield put(success(promise));
        else {
          if (failed)
            yield put(failed(promise));
          else
            yield put({ type: 'ERROR', message: promise && promise.error });
        }
      }
      else {
        console.log('session expired');
        yield put({ type: 'SHOW_SESSION_EXPIRED' });
      }
    } catch (e) {
      console.log('API call failed. URL: ' + url);
      console.log('Exception Detail: ' + e);
      yield put({ type: 'API_EXCEPTION', e });
    }
    finally {
      //hide loading icon
      yield put({ type: 'LOADING', val: -1 });
    }

  }
};
export default sagaUtil;